// mobile dropdown
$(".mobile_nav").on("click", function () {
	setTimeout(() => {
		if ($(this).find("div").hasClass("open")) {
			$('div.dropdown_container[data-dropdown="menu"]').show();
			$("body").css("overflow", "hidden");
		} else {
			$('.mobile-nav-header .dropdown_container[data-dropdown="menu"]').hide();
			$("body").css("overflow", "auto");
		}
	}, 50);
});

// desktop navigation function
$(".desktop-nav ul.menu li a.dropdown_link").on("mouseover", function () {
	// hide all mega menu
	$(`.mega-menu-container .dropdown_container`).hide();
	const dataDropdownRef = $(this).data("dropdown-rel");
	// show the correct mega menu
	setTimeout(() => {
		$(`.mega-menu-container .dropdown_container[data-dropdown="${dataDropdownRef}"]`).show();
	}, 50);
});
$(`.mega-menu-container .dropdown_container`).on("mouseover", function () {
	$(this).show();
});
$(`.mega-menu-container .dropdown_container`).on("mouseleave", function () {
	$(this).hide();
});
$("a.top_link, .desktop-middle-header").on("mouseover", function () {
	$(`.mega-menu-container .dropdown_container`).hide();
});
